/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';

import ScoreBoard from 'solis/claude/projection/score.board';


export default class BoardAuthority extends Logic
{
  constructor (board, date)
  {
    super(board, date);

    this.mutate(ScoreBoard, date);
  }


  getCurrentValue (colony)
  {
    return Math.floor(colony.cass.authority);
  }


  getNextValue (colony)
  {
    return Math.floor(this.object.getColony(colony.cass.id).cass.authority);
  }


  getNextIncrease (colony)
  {
    return Math.floor(this.object.getColony(colony.cass.id).cass.authority - colony.cass.authority);
  }


};
